// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"4b634e73","454":"dea22479","864":"4b634e73"}[chunkId] + ".chunk.css";
};